<template>
  <div class="wrapper">
    <div class="content">
      <div class="contentTop">
        <div class="factoryName">
          <img src="~assets/caiLogo.png" alt="" /><span
            style="padding-left: 10px"
            >浙江才府玻璃-数字化工厂 (德清二厂)</span
          >
        </div>
        <div class="dateInfo">
          <div class="title">{{ date }}</div>
          <div style="display: flex">
            <div style="display;flex;align-items: center;">
              <div style="display: flex">
                <a-button
                  class="fullbutton"
                  @click="fullScreen"
                  size="small"
                  v-show="!screenFlag"
                  ><a-icon type="fullscreen" /></a-button
                ><a-button
                  class="smallbutton"
                  @click="smallScreen"
                  size="small"
                  v-show="screenFlag"
                  ><a-icon type="fullscreen"
                /></a-button>
                <a-button class="fullbutton" size="small" @click="toPage">
                  <a-icon type="reload" />
                </a-button>
              </div>
            </div>
            <div class="time">{{ time }}</div>
          </div>
        </div>
      </div>
      <div class="contentMiddle">
        <div class="dosing">
          <div v-for="item in data2" :key="item.index">
            <dosing :data="item"></dosing>
          </div>
        </div>
        <div class="stoveTempers">
          <div v-for="item in data" :key="item.index">
            <stoveTemper :data="item"></stoveTemper>
          </div>
        </div>
        <div class="detailInfo">
          <detail-info :tem="tem"></detail-info>
          <list :listData="listData"></list>
        </div>
        <div class="contentRight">
          <div class="contentRightTitle">
            <a-icon type="instagram" />
            <span>退火炉</span>
          </div>
          <div v-for="item in data3" :key="item.index">
            <div style="display: flex; align-items: center">
              <div class="annealing">
                <annealing :value="item.value"></annealing>
              </div>
              <div class="othersInfo">
                <div class="ammeter">{{ item.ammeter }}</div>
                <div class="maxPressure">
                  <div
                    style="width: 10px; height: 10px; background-color: #c9646a"
                  ></div>
                  <div class="maxPressureDetail">
                    电压上限：{{ item.maxPressure }}V
                  </div>
                </div>
                <div class="minPressure">
                  <div
                    style="width: 10px; height: 10px; background-color: #227ace"
                  ></div>
                  <div class="maxPressureDetail">
                    电压下限：{{ item.minPressure }}V
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table">
            <TableList :data="dataList" v-show="dataList"></TableList>
          </div>
          <div class="checked">
            <checked :data="progressData" v-show="progressData"></checked>
          </div>
        </div>
      </div>
      <!-- <div class="annotation">
        <div>技术支持：杭州制保科技有限公司</div>
        <div style="float: right">
          <a-button class="fullbutton" size="small" @click="toPage">
            <a-icon type="fullscreen" />
          </a-button>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  getkilnTemp,
  getmaterialsLib,
  getfeedChannel,
  getdetest,
  getannealing,
} from "../network/glassScreen";
import checked from "./test10Children/checked.vue";
import TableList from "./test10Children/table.vue";
import annealing from "./test10Children/annealing.vue";
import list from "./test10Children/list.vue";
import detailInfo from "./test10Children/detailInfo.vue";
import dosing from "./test10Children/dosing.vue";
import stoveTemper from "./test10Children/stoveTemper.vue";
export default {
  name: "",
  data() {
    return {
      listData: "",
      tem: [
        {
          title: "1号煤气发生炉",
          arr: [
            {
              smallTitle: "电压指示",
              currentTem: 35.3,
              maxTem: 200,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 25.3,
              maxTem: 25,
              minTem: 15,
            },
            {
              smallTitle: "下段巡检",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
          ],
        },
        {
          title: "2号煤气发生炉",
          arr: [
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
            {
              smallTitle: "电压指示",
              currentTem: 15.3,
              maxTem: 20,
              minTem: 10,
            },
          ],
        },
      ],
      progressData: "",
      dataList: "",
      data: [
        {
          title: "3号窑炉",
          list: ["窑炉状态", "实时信息"],
          info: {
            nameArr: [
              "二氧化硫",
              "氧气含量",
              "烟尘浓度",
              "烟尘流速",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
            ],
            currentTemArr: [
              "16",
              "21",
              "25",
              "35",
              "22",
              "12",
              "21",
              "23",
              "16",
              "21",
              "25",
              "35",
              "22",
              "12",
              "21",
              "23",
            ],
          },
        },
        {
          title: "5号窑炉",
          list: ["窑炉状态", "实时信息"],
          info: {
            nameArr: [
              "二氧化硫",
              "氧气含量",
              "烟尘浓度",
              "烟尘流速",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
              "炉底南",
            ],
            currentTemArr: [
              "160",
              "211",
              "25",
              "35",
              "22",
              "12",
              "21",
              "23",
              "16",
              "21",
              "25",
              "35",
              "22",
              "12",
              "21",
              "223",
            ],
          },
        },
      ],
      data2: null,
      data3: [
        {
          value: 555,
          ammeter: "一区表",
          maxPressure: 155,
          minPressure: 100,
        },
        {
          value: 222,
          ammeter: "二区表",
          maxPressure: 155,
          minPressure: 100,
        },
        {
          value: 111,
          ammeter: "三区表",
          maxPressure: 155,
          minPressure: 100,
        },
      ],
      timeInterver: "",
      timeOut: "",
      timtOver: "",
      timeFlow: "",
      timeHidde: "",
      date: "",
      time: "",
      week: "",
      screenFlag:false,
    };
  },
  components: {
    stoveTemper,
    dosing,
    detailInfo,
    list,
    annealing,
    TableList,
    checked,
  },
  created() {
    this.getkilnTemp();
    this.getmaterialsLib();
    this.getfeedChannel();
    this.getdetest();
    this.getannealing();
    this.todo();
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.fshandler);
    document.addEventListener("webkitfullscreenchange", this.fshandler);
    document.addEventListener("mozfullscreenchange", this.fshandler);
    document.addEventListener("MSFullscreenChange", this.fshandler);
  },
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.fshandler);
    document.removeEventListener("webkitfullscreenchange", this.fshandler);
    document.removeEventListener("mozfullscreenchange", this.fshandler);
    document.removeEventListener("MSFullscreenChange", this.fshandler);
    this.timeInterver && clearTimeout(this.timeInterver);
    this.timeOut && clearTimeout(this.timeOut);
    this.timtOver && clearTimeout(this.timtOver);
    this.timeFlow && clearTimeout(this.timeFlow);
    this.timeHidde && clearTimeout(this.timeHidde);
  },
  methods: {
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var week = date.getDay();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var Seconds = date.getSeconds();
      this.date = `${year}年 ${month}月 ${day}日`;
      this.time = `${hours}:${minutes}:${Seconds}`;
      var a = ["日", "一", "二", "三", "四", "五", "六"];
      var week = date.getDay();
      this.week = "星期" + a[week];
      // console.log(`${year}-${month}-${day}-${week}-${hours}:${minutes}`);
    },
    todo() {
      setInterval(this.getTime, 500);
    },
    smallScreen() {
      var el = document;
      var cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    fullScreen() {
      let elem = document.querySelector(".wrapper");
      let requestMethod =
        elem.requestFullScreen ||
        elem.webkitRequestFullScreen ||
        elem.mozRequestFullScreen ||
        elem.msRequestFullScreen;
      console.log(requestMethod);
      if (requestMethod) {
        requestMethod.call(elem);
      } else if (typeof window.ActiveXObject !== "undefined") {
        let wscript = new window.ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    fshandler() {
      let flag = !this.screenFlag;
      this.screenFlag = flag;
    },
    toPage() {
      this.$router.push({
        name: "factorystatus",
      });
    },
    getkilnTemp() {
      getkilnTemp().then(
        (res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.data = res.data.data;
            this.timeInterver && clearTimeout(this.timeInterver);
            this.timeInterver = setTimeout(() => {
              this.getkilnTemp();
            }, 3000);
          } else {
            this.timeInterver && clearTimeout(this.timeInterver);
            this.timeInterver = setTimeout(() => {
              this.getkilnTemp();
            }, 3000);
          }
        },
        (err) => {
          this.timeInterver && clearTimeout(this.timeInterver);
          this.timeInterver = setTimeout(() => {
            this.getkilnTemp();
          }, 3000);
        }
      );
    },
    getmaterialsLib() {
      getmaterialsLib().then(
        (res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.data2 = res.data.data;
            this.timeOut && clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
              this.getmaterialsLib();
            }, 3000);
          } else {
            this.timeOut && clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
              this.getmaterialsLib();
            }, 3000);
          }
        },
        (err) => {
          this.timeOut && clearTimeout(this.timeOut);
          this.timeOut = setTimeout(() => {
            this.getmaterialsLib();
          }, 3000);
        }
      );
    },
    getfeedChannel() {
      getfeedChannel().then(
        (res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.listData = res.data.data;
            this.timtOver && clearTimeout(this.timtOver);
            this.timtOver = setTimeout(() => {
              this.getfeedChannel();
            }, 3000);
          } else {
            this.timtOver && clearTimeout(this.timtOver);
            this.timtOver = setTimeout(() => {
              this.getfeedChannel();
            }, 3000);
          }
        },
        (err) => {
          this.timtOver && clearTimeout(this.timtOver);
          this.timtOver = setTimeout(() => {
            this.getfeedChannel();
          }, 3000);
        }
      );
    },
    getdetest() {
      getdetest().then(
        (res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.progressData = res.data.data;
            this.timeFlow && clearTimeout(this.timeFlow);
            this.timeFlow = setTimeout(() => {
              this.getdetest();
            }, 3000);
          } else {
            this.timeFlow && clearTimeout(this.timeFlow);
            this.timeFlow = setTimeout(() => {
              this.getdetest();
            }, 3000);
          }
        },
        (err) => {
          this.timeFlow && clearTimeout(this.timeFlow);
          this.timeFlow = setTimeout(() => {
            this.getdetest();
          }, 3000);
        }
      );
    },
    getannealing() {
      getannealing().then(
        (res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.dataList = res.data.data;
            this.timeHidde && clearTimeout(this.timeHidde);
            this.timeHidde = setTimeout(() => {
              this.getannealing();
            }, 3000);
          } else {
            this.timeHidde && clearTimeout(this.timeHidde);
            this.timeHidde = setTimeout(() => {
              this.getannealing();
            }, 3000);
          }
        },
        (err) => {
          this.timeHidde && clearTimeout(this.timeHidde);
          this.timeHidde = setTimeout(() => {
            this.getannealing();
          }, 3000);
        }
      );
    },
  },
};
</script>
<style scoped>
.wrapper {
  background-color: black;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.contentTop {
  display: flex;
  color: #c8c9cd;
  justify-content: space-between;
  background-color: #1f2b39;
  margin: 10px;
  height: 60px;
  align-items: center;
}
.factoryName {
  font-size: 28px;
  padding-left: 10px;
}
.title {
  font-size: 15px;
}
.time {
  font-size: 20px;
}
.dateInfo {
  padding-right: 10px;
}
.contentMiddle {
  width: 100%;
  margin-left: 10px;
  display: flex;
}
.dosing {
  width: 22%;
  border-top: 2px solid #bd5917;
}
.stoveTempers {
  width: 10%;
  margin-left: 5px;
  border-top: 2px solid #1274c2;
}
.detailInfo {
  width: 45%;
  height: 450px;
  margin-left: 5px;
}
.contentRight {
  width: 22%;
  height: 450px;
  display: flex;
  flex-direction: column;
  border-top: 2px solid #a3565d;
  margin: 0px 15px 0px 10px;
  background-color: #202834;
}
.othersInfo {
  color: #9c9fa6;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.ammeter {
  margin-bottom: 10px;
}
.maxPressure {
  height: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.minPressure {
  display: flex;
  align-items: center;
  height: 20px;
  margin-bottom: 5px;
}
.maxPressureDetail {
  height: 20px;
  color: #9c9fa6;
  padding-left: 5px;
}
.annealing {
  height: 120px;
}
.table {
  width: 100%;
}
.checked {
  width: 100%;
  margin-top: 10px;
  height: 360px;
  background-color: #202834;
}
.contentRightTitle {
  color: #fff;
  font-size: 15px;
}
.annotation {
  color: #fff;
  font-weight: bold;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/plasticfactory.vue